import Styles from './UnreadDot.module.scss'
import cx from 'classnames'

interface Props {
  isUnread?: boolean
  className?: string
}

export const UnreadDot = ({ isUnread = true, className }: Props) => {
  if (!isUnread) return null

  return <div className={cx(Styles.unreadDot, className)} data-testid="unread-indicator" />
}
